<template>
  <v-container>
    <v-row>
      <v-col :cols="9">
        <v-text-field
          v-model="guid"
          label="Ticket Attachment Code"
          id="guidText"
          readonly
        ></v-text-field>
      </v-col>
      <v-col :cols="3">
        <v-btn ref="btnCopy" dark block @click="copyToClipboard">Copy</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import uuid from "uuid/v4";

export default {
  name: "TicketAttachmentsCode",
  data: () => ({
    guid: uuid()
  }),
  mounted: function() {
    this.$emit("codeGenerated", this.guid);
  },
  methods: {
    /* istanbul ignore next */
    copyToClipboard() {
      window.navigator.clipboard.writeText(this.guid);
    }
  }
};
</script>

<style scoped>
.v-btn {
  background-image: linear-gradient(to right, #2685f4, #3a3dd1) !important;
}
</style>
